export const citiesApiUrl = 'https://wft-geo-db.p.rapidapi.com/v1/geo';
export const apiOptions = {
    method: 'GET',
    headers: {
        'X-RapidAPI-Key': 'bdf521a2a9mshbb7ffd8f8f5e391p16a975jsn96b4c1d379cf',
        'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
    }
};

export const weatherApiUrl = 'https://api.openweathermap.org/data/2.5'
export const weatherApiKey = 'df85d7a67c19929e5be166049af5d319'
